import UploadImageFormFields from '@Containers/UploadImageFormFields';
import { Box } from '@mui/material';

type PerformanceGhgasMgmtUploadImageProps = {
  isCompletedEn: boolean;
  isCompletedTh: boolean;
};

const PerformanceGhgasMgmtUploadImage = (
  props: PerformanceGhgasMgmtUploadImageProps
) => {
  const { isCompletedEn, isCompletedTh } = props;

  return (
    <Box mt={2}>
      <UploadImageFormFields
        title={
          'รูปภาพผลการดำเนินงานและผลลัพธ์ด้านการจัดการจัดการก๊าซเรือนกระจก'
        }
        name={`performanceGhGasMgmtReport.performanceGhGasMgmt`}
        disabledEn={isCompletedEn}
        disabledTh={isCompletedTh}
      />
    </Box>
  );
};

export default PerformanceGhgasMgmtUploadImage;
